import { render } from "./RecoverPasswordComponent.vue?vue&type=template&id=44618dd8&scoped=true"
import script from "./RecoverPasswordComponent.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordComponent.vue?vue&type=script&lang=js"

import "./RecoverPasswordComponent.vue?vue&type=style&index=0&id=44618dd8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44618dd8"]])

export default __exports__